export const safeJsonParse = <T>(json: string, defaultValue: T): T => {
    try {
        const parsed = JSON.parse(json) as T;
        return parsed ?? defaultValue;
    } catch (error) {
        return defaultValue;
    }
};
